import React from 'react'
import clsx from 'clsx'
import { RiAddLine, RiCloseLine } from 'react-icons/ri'
import { AnimatePresence, motion } from 'framer-motion'

import useStyles, { StyledButton } from './styles'

type FloatingActionButtonProps = {
  anchorProps?: any
  children?: (
    onClick: () => void,
    buttonClass: string,
    iconClass: string
  ) => JSX.Element
}

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({
  anchorProps = {},
  children
}) => {
  const [open, setOpen] = React.useState(false)
  const icon = React.useMemo(
    () => (open ? <RiCloseLine /> : <RiAddLine />),
    [open]
  )

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div
        className={clsx(classes.menuAnchor, anchorProps.className)}
        {...anchorProps}
      >
        <AnimatePresence>
          {open && (
            <motion.div
              className={classes.menu}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              {children &&
                children(() => setOpen(false), classes.button, classes.icon)}
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <StyledButton
        data-testid='FloatingActionButton'
        onClick={() => setOpen(old => !old)}
      >
        {icon}
      </StyledButton>

      {open && (
        <div onClick={() => setOpen(false)} className={classes.backdrop} />
      )}
    </div>
  )
}

export default FloatingActionButton
